import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=4b149fd4&scoped=true"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"
import style0 from "./UI.vue?vue&type=style&index=0&id=4b149fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b149fd4",
  null
  
)

export default component.exports